import axios from "../utils/axios";
import {IContract} from "../models/Contract";
import {fetchAndParse} from "./utilts";

export function fetchContracts(id: string, token: string ) {
  return new Promise((resolve, reject) => {
    axios
      .get<IContract>(`${process.env.REACT_APP_API_DOMAIN}/hubspot-contracts/?company=${id}`, {
        headers: { Authorization: "Token " + token },
      })
      .then((response: any) => {
        if (response.status === 200) {
          const contract: IContract = response.data.results
          resolve(contract);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function retrieveContractOptions(token: string) {
  const url = new URL(
    `/hubspot-contracts/`,
    process.env.REACT_APP_API_DOMAIN
  );
  return fetchAndParse<any>(url.toString(), {
    method: "OPTIONS",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Token " + token,
    },
  });
}

export function fetchProducts(token: string ) {
  return new Promise((resolve, reject) => {
    axios
      .get<IContract>(`${process.env.REACT_APP_API_DOMAIN}/hubspot-products/?limit=999`, {
        headers: { Authorization: "Token " + token },
      })
      .then((response: any) => {
        if (response.status === 200) {
          resolve(response.data.results);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}